import { render, staticRenderFns } from "./AditivarContrato.vue?vue&type=template&id=70b37ff8"
import script from "./AditivarContrato.vue?vue&type=script&lang=js"
export * from "./AditivarContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports